import { __assign } from "tslib";
import { Chip, styled } from '@mui/material';
import { alpha } from '@mui/system';
export var StyledChip = styled(Chip, {
    shouldForwardProp: function (prop) { return !['rounded', 'active'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, rounded = _a.rounded, variant = _a.variant, color = _a.color, active = _a.active;
    return (__assign(__assign(__assign(__assign({}, (rounded && {
        borderRadius: "3px",
    })), (!color && __assign(__assign(__assign(__assign({ color: theme.palette.greySecondary.main, backgroundColor: alpha(theme.palette.greySecondary.A100, 0.4), '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.6),
        }, '&:active': {
            boxShadow: "none",
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.8),
        } }, (variant === 'outlined' && {
        color: theme.palette.greySecondary.main,
        border: "1px solid",
        borderColor: theme.palette.greySecondary[300],
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
        },
        '&:active': {
            boxShadow: "none",
            // backgroundColor: alpha(theme.palette.greySecondary.main, 0.12),
        },
        '&.MuiChip-clickable': {
            '&:hover': {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            },
        },
        '.MuiChip-deleteIcon': {
            color: theme.palette.greySecondary[500],
        },
    })), (variant === 'filled' && {
        color: theme.palette.greySecondary.contrastText,
        backgroundColor: theme.palette.greySecondary.main,
        '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.8),
        },
        '&:active': {
            boxShadow: "none",
            backgroundColor: theme.palette.greySecondary.main,
        },
        '.MuiChip-deleteIcon': {
            color: theme.palette.greySecondary.contrastText,
            '&:hover': {
                color: theme.palette.greySecondary.contrastText,
            },
        },
    })), (variant === 'filter' && __assign(__assign({ backgroundColor: theme.palette.common.white, '.MuiBox-root': {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            borderRadius: 20,
            // '.MuiSvgIcon-root': {
            //   '&[data-testid="ArrowDropDownIcon"]': {
            //     fill: theme.palette.secondary[500],
            //     path: {
            //       d: `path("m1844 760 4-8h-8l4 8")`,
            //       transform: `translate(-1832.001px, -744px)`,
            //     },
            //   },
            // },
        }, '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            '.MuiBox-root': {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            },
        } }, (active && {
        backgroundColor: alpha(theme.palette.greySecondary.A100, 0.4),
        '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.8),
            '.MuiBox-root': {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            },
        },
    })), { '&.Mui-disabled': {
            opacity: 1,
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            '>  *': {
                opacity: 0.48,
            },
        } }))), (variant === 'search' && __assign(__assign({ backgroundColor: alpha(theme.palette.greySecondary.main, 0.08), '.MuiBox-root': {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 20,
            height: 20,
            borderRadius: 20,
            // '.MuiSvgIcon-root': {
            //   '&[data-testid="ArrowDropDownIcon"]': {
            //     fill: theme.palette.secondary[500],
            //     path: {
            //       d: `path("m1844 760 4-8h-8l4 8")`,
            //       transform: `translate(-1832.001px, -744px)`,
            //     },
            //   },
            // },
        }, '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.4),
            '.MuiBox-root': {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            },
        } }, (active && {
        backgroundColor: alpha(theme.palette.greySecondary.A100, 0.4),
        '&:hover': {
            backgroundColor: alpha(theme.palette.greySecondary.A100, 0.8),
            '.MuiBox-root': {
                backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            },
        },
    })), { '&.Mui-disabled': {
            opacity: 1,
            backgroundColor: alpha(theme.palette.greySecondary.main, 0.08),
            '>  *': {
                opacity: 0.48,
            },
        } }))))), (color && __assign(__assign({}, (variant === 'outlined' && {
        color: theme.palette[color].main,
        border: "1px solid",
        borderColor: alpha(theme.palette[color].main, 0.4),
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, 0.08),
        },
        '&:active': {
            boxShadow: "none",
            backgroundColor: alpha(theme.palette[color].main, 0.12),
        },
        '&.MuiChip-clickable': {
            '&:hover': {
                backgroundColor: alpha(theme.palette[color].main, 0.08),
            },
        },
        '.MuiChip-deleteIcon': {
            color: theme.palette[color].main,
            '&:hover': {
                color: theme.palette[color].main,
            },
        },
    })), (variant === 'filled' && {
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, 0.8),
        },
        '.MuiChip-deleteIcon': {
            color: theme.palette[color].contrastText,
            '&:hover': {
                color: theme.palette[color].contrastText,
            },
        },
    })))), (!variant && __assign({}, (color && {
        color: theme.palette[color].main,
        // backgroundColor: theme.palette[color].main,
        backgroundColor: alpha(theme.palette[color].main, 0.1),
        '&:hover': {
            backgroundColor: alpha(theme.palette[color].main, 0.12),
        },
        '&:active': {
            boxShadow: "none",
            backgroundColor: alpha(theme.palette[color].main, 0.16),
        },
        '.MuiChip-deleteIcon': {
            color: theme.palette[color].main,
            '&:hover': {
                color: theme.palette[color].main,
            },
        },
    })))));
});
//# sourceMappingURL=styled.js.map